exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".lbaLoader{background:#fff;opacity:.8;position:fixed;top:0;left:0;right:0;bottom:0;z-index:1000}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaLoader/src/components/lbaLoader/lbaLoader.scss"],"names":[],"mappings":"AAAA,WACI,gBACA,WACA,eACA,MACA,OACA,QACA,SACA,YAAa,CAChB","file":"lbaLoader.scss","sourcesContent":[".lbaLoader {\r\n    background: #fff;\r\n    opacity: 0.8;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    z-index: 1000;\r\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sass-loader?sourceMap!./src/components/lbaLoader/lbaLoader.scss
// module id = 199
// module chunks = 0